<template>
<div :ref="LoadingObj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">订单详情</span>
        <div class="TTL-BTN-LIST">
            <wcbutton :option="{title:'返回订单管理',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsOrder'})}" />
        </div>
    </div>

    <div class="ttl-goods-table top40">
        <table border="1" style="border-collapse: collapse;border-spacing: 0;">
            <tr>
                <td width="25%" align="center">订单号码</td>   
                <td width="25%" align="center">{{orderinfo.order_sn}}</td>
                <td width="25%" align="center">订单状态</td>   
                <td width="25%" align="center">{{orderinfo.statusname}}</td>
            </tr>
            <tr>
                <td width="25%" align="center">支付金额</td>   
                <td width="25%" align="center">￥{{orderinfo.orderprice}}</td>
                <td width="25%" align="center">支付单号</td>   
                <td width="25%" align="center">{{orderinfo.pay_transition_sn}}</td>
            </tr>    
            <tr>
                <td width="25%" align="center">买家</td>
                <td width="25%" align="center">{{orderinfo.buyermembername}}</td>    
                <td width="25%" align="center">买家手机</td>
                <td width="25%" align="center">{{orderinfo.buyermemberphone}}</td>
            </tr>
            <tr>
                <td width="25%" align="center">卖家</td>
                <td width="25%" align="center">{{orderinfo.salemembername}}</td>    
                <td width="25%" align="center">卖家手机</td>
                <td width="25%" align="center">{{orderinfo.salememberphone}}</td>
            </tr>
            <tr>
                <td width="25%" align="center">外卖配送</td>
                <td width="25%" align="center">{{orderinfo.shippingmembername}}</td>    
                <td width="25%" align="center">外卖配送手机</td>
                <td width="25%" align="center">{{orderinfo.shippingmemberphone}}</td>
            </tr>
            <tr>
                <td width="25%" align="center">支付方式</td>
                <td width="25%" align="center">{{orderinfo.pay_type}}</td>    
                <td width="25%" align="center">下单时间</td>
                <td width="25%" align="center">{{orderinfo.inputtime}}</td>
            </tr>
            <tr>
                <td width="25%" align="center">支付时间</td>
                <td width="25%" align="center">{{orderinfo.paytime}}</td>    
                <td width="25%" align="center">外卖确认时间</td>
                <td width="25%" align="center">{{orderinfo.shippingtime}}</td>
            </tr>
            <tr>
                <td width="25%" align="center">买家确认时间</td>
                <td width="25%" align="center">{{orderinfo.buyertime}}</td>    
                <td width="25%" align="center">卖家确认时间</td>
                <td width="25%" align="center">{{orderinfo.saletime}}</td>
            </tr>
            <tr>
                <td colspan="4">
                    <div class="TTL-order-info" v-for="(item,index) in orderinfo.goods" :key="index">
                        <div class="TTL-order-title"><wcimage :value="item.goodsthumb" :option="{size:'middle'}" /></div>
                        <div class="TTL-order-title left10">{{item.goodsname}}</div>
                        <div class="TTL-order-title left10">￥{{item.goodsprice}}</div>
                        <div class="TTL-order-title left10">{{item.goodsnum}}</div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
            
</div>

</template>

<script>

export default {
    components:{},
    data() {
        return {
            LoadingObj:'OrderDetail',  //loading对象   
            orderinfo:{}, //订单信息 

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.orderinfo=data.param;
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.orderinfo=data.param;
            } 
        },

    },
}
</script>
<style scoped>
.ttl-goods {padding:20px 15px 50px 15px;width:calc(100% - 30px);}
.ttl-member-info {display: inline-flex;align-items: center;width:100%;font-size:0;}
.ttl-member-info i {font-style: normal;color:#666eeb;font-size:13px;cursor: pointer;}
.ttl-member-info .el-image {width:80px;height:80px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info span {display: inline-flex;align-items: center;font-size:13px;color:#666666;}
.ttl-frozen {box-shadow: 0 !important;width:20px !important;height: 20px !important;}
.ttl-member-status {display: inline-flex;align-items: center;}

.ttl-goods-table {display:inline-block;width:100%;}
.ttl-goods-table table {width:100%;border-color: #EBEDF0;padding:0;}
.ttl-goods-table table th {background-color: #EBEDF0;}
.ttl-goods-table table th,.ttl-goods-table table td {padding:20px;font-size:13px;color:#333333;font-weight: normal;}
.ttl-goods-table .el-image {width:60px;height: 60px;border-radius: 50%;box-shadow: 0 0 10px #EBEDF0;}
.numbers {color:#666eeb;cursor: pointer;}
.TTL-order-info {display: inline-flex;width:100%;align-items: center;}
.TTL-order-title {width:calc((100% - 60px - 30px) / 3);font-size:13px;line-height: 18px;color:#666666;text-align: center;}
.ttl-goods-table .el-image {border-radius: 15px;}
</style>